import requests from '../../request'

const baseUrl = '/basedata/supplier'
const selectorBaseUrl = '/selector'

/**
 * 供应商选择器查询
 */
export function selector(params) {
  return requests({
    url: selectorBaseUrl + '/supplier',
    method: 'get',
    params
  })
}

/**
 * 批量加载供应商
 */
export function loadSupplier(data) {
  return requests({
    url: selectorBaseUrl + '/supplier/load',
    method: 'post',
    data,
  }, {
    contentType: 'application/json;charset=UTF-8'
  })
}

/**
 * 查询列表
 */
export function query(params) {
  return requests({
    url: baseUrl + '/query',
    method: 'get',
    params
  })
}

/**
 * 根据ID查询
 * @param id
 */
export function get(id) {
  return requests({
    url: baseUrl,
    method: 'get',
    params: {
      id: id
    }
  })
}

/**
 * 批量停用
 * @param ids
 */
export function batchUnable(ids) {
  return requests({
    url: baseUrl + '/unable/batch',
    method: 'patch',
    data: ids
  }, {
    contentType: 'application/json;charset=UTF-8'
  })
}

/**
 * 批量启用
 * @param ids
 */
export function batchEnable(ids) {
  return requests({
    url: baseUrl + '/enable/batch',
    method: 'patch',
    data: ids
  }, {
    contentType: 'application/json;charset=UTF-8'
  })
}

/**
 * 新增
 * @param data
 */
export function create(data) {
  return requests({
    url: baseUrl,
    method: 'post',
    data
  }, {
    contentType: 'application/x-www-form-urlencoded;charset=UTF-8'
  })
}

/**
 * 修改
 * @param data
 */
export function update(data) {
  return requests({
    url: baseUrl,
    method: 'put',
    data
  }, {
    contentType: 'application/x-www-form-urlencoded;charset=UTF-8'
  })
}

/**
 * 下载导入模板
 */
export function downloadImportTemplate() {
  return requests({
    url: baseUrl + '/import/template',
    method: 'get',
    responseType: 'blob'
  })
}

/**
 * 导入
 */
export function importExcel(data) {
  return requests({
    url: baseUrl + '/import',
    method: 'post',
    data
  }, {
    contentType: 'multipart/form-data'
  })
}